import Text from "common/Typography/Text";
import { displayResultMessage } from "utils/misc";
import { LoginRequest, OAuthUserRequest } from "@shared/types";
import { PrimaryTitle, Wrapper } from "features/auth/styles";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import React from "react";
import { Security } from "common/Icons/Icons";
import VerificationCode from "features/auth/VerificationCode";
import { sharedLib } from "@shared/services/shared.service";
import { handleUserTempOAuthData } from "@shared/features/onboarding/utils";
import { triggerSaveNativeBiometric } from "services/webview/webViewBridgeUtils";

interface TwoFALoginProps {
  loginDetails: LoginRequest | OAuthUserRequest;
}

export const TwoFALogin = ({ loginDetails }: TwoFALoginProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const [login, loginStatus] =
    sharedLib.sharedApi.authentication.useLoginMutation();
  const [oauthUser, oauthUserStatus] =
    sharedLib.sharedApi.authentication.useOauthUserMutation();
  const isLoading = loginStatus.isLoading || oauthUserStatus.isLoading;

  const onSubmit = (code: string) => {
    const loginRequest = { ...loginDetails, two_factor_token: code };
    if ("email" in loginDetails) {
      displayResultMessage(login(loginRequest as LoginRequest).unwrap())
        .then(() => {
          triggerSaveNativeBiometric(loginDetails);
        })
        .catch(() => {});
    } else {
      displayResultMessage(oauthUser(loginRequest as OAuthUserRequest).unwrap())
        .then(async (result) => {
          if (result?.user_id) {
            handleUserTempOAuthData(result.user_id);
          }
        })
        .catch(() => {});
    }
  };

  return (
    <Wrapper $isMobile={isMobile}>
      <PrimaryTitle $isMobile={isMobile}>Security Verification</PrimaryTitle>
      <Security style={{ marginBottom: 24 }} />
      <Text>
        To secure your account, please, complete the following verification.
        Enter 6 digits code from Google Authenticator.
      </Text>
      <VerificationCode
        numOfDigits={NUM_OF_DIGITS_CODE}
        title="Google Verification code"
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    </Wrapper>
  );
};

const NUM_OF_DIGITS_CODE = 6;
